import React, { useState, useContext, createContext, useMemo } from 'react';

const MenuContext = createContext({});

export function MenuProvider({ children }) {
  const [expandedItem, setExpandedItem] = useState(null);
  const [selectedItem, setSelectedItem] = useState(0);
  const [selectedSubItem, setSelectedSubItem] = useState(0);
  const [openMenu, setOpenMenu] = useState(() => {
    return window.innerWidth >= 768;
  });

  const handleMenu = () => {
    setOpenMenu((old) => !old);
  };

  const closeMenu = () => {
    setOpenMenu(false);
  };

  const contextValue = useMemo(
    () => ({
      openMenu,
      handleMenu,
      closeMenu,
      setOpenMenu,
      setExpandedItem,
      expandedItem,
      setSelectedItem,
      selectedItem,
      setSelectedSubItem,
      selectedSubItem,
    }),
    [openMenu, expandedItem, selectedItem, selectedSubItem],
  );
  return (
    <MenuContext.Provider value={contextValue}>{children}</MenuContext.Provider>
  );
}

export function useMenu() {
  const context = useContext(MenuContext);

  if (!context) throw new Error('useMenu must be used within a MenuProvider');

  return context;
}
